const state = {
  layerVisibility: {}, // { 'LUPC Zones': true, 'Statewide Standards': false, etc. }
};

const mutations = {
  SET_LAYER_VISIBILITY(state, { layerTitle, visible }) {
    state.layerVisibility = {
      ...state.layerVisibility,
      [layerTitle]: visible,
    };
  },
  SET_ALL_LAYER_VISIBILITY(state, layerVisibility) {
    state.layerVisibility = { ...layerVisibility };
  },
};

const actions = {
  setLayerVisibility({ commit }, payload) {
    commit('SET_LAYER_VISIBILITY', payload);
  },
  setAllLayerVisibility({ commit }, layerVisibility) {
    commit('SET_ALL_LAYER_VISIBILITY', layerVisibility);
  },
};

const getters = {
  getLayerVisibility: state => layerTitle => state.layerVisibility[layerTitle],
  allLayerVisibility: state => state.layerVisibility,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
